import React, { useEffect, useRef, useState } from "react";
import { Link, useHistory, withRouter } from 'react-router-dom';
import style from './pricing.module.scss';
import Searchbar from "../productSearchbar/productSearchbar";
import Pagination from "../pagination/pagination";
import MobilePagination from "../mobilePagination/mobilePagination"
import TinyDropdown from "../Dropdown/tinyDropdown/tinyDropdown";
import toPersianNumber from "../../helpers/actions/toPersianNumber";
import toEnglishNumber from "../../helpers/actions/toEnglishNumber";
import disconnectTextGenerator from '../../helpers/actions/disconnectedText'
import PricingFilters from './pricingFilters/pricingFilters'
import PricingColoredFilters from "./pricingFilters/pricingColoredFilters";
import PricingCard from "./pricingCard/pricingCard";
import MobilePricingCard from "./mobilePricingCard/mobilePricingCard"
import MobileFilters from "./mobileFilters/mobileFilters"
import Button from "../Button/button"
import CommentInsight from "../comments insights/commentInsight"
import {
    EditSingleVariantModalCalc, GetBrands, getPricingList, GetSellers, RepriceVariant, GetSingleVariant,
    GetErrors, GetproductGroup, SubmitAddChannel, ChangeSalesPrice, CompleteProgressBar, GetProgressBar
} from "../../actions/APIcalls"
import EditModal2 from "./editModal/EditModal2"
import ChangeRouteModal from "../changeRouteModal/Modal"
import Toast from "../Toast/Toast"
import GradientToast from "../gradientToast/Toast"
import Skeleton from "./skeleton"
import { ErrorsFilterValues, variantState } from "../../helpers/consts/pricingConsts"
import EditChannelModal from "../editChannelModal/editChannelModal";
import noVariantEmptyState from '../../assets/icons/EmptyStates/variant_noactivevariant.svg'
import noResultEmptyState from '../../assets/icons/EmptyStates/variant_noresult.svg'
import GeneralWarning from "../generalWarning/warning"


const strategyValues = [
    {
        name: "کمترین قیمت",
        value: "lowestPrice"
    },
    {
        name: "موجود در باکس(لحظه‌ای)",
        value: "boxMoment"
    },
    {
        name: "موجود در باکس(پلکانی)",
        value: "boxStep"
    },
    {
        name: "باکس هوشمند",
        value: "aiSmart"
    },
]
const FilterArrays = [
    { tag: "variantState", name: "وضعیت تنوع" }, { tag: "productGroup", name: "گروه کالا" }, { name: "برند", tag: "brand" }, { tag: "pricingStrategy", name: "استراتژی" },
    { tag: "ErrorFilter", name: "خطاها" }, { name: "تخفیف هوشمند", tag: "promotion" }, { name: "فروشنده", tag: "channel" }
]
const Pricing = (props) => {

    const [editModal, setEditModal] = useState({
        show: false,
    })
    const [hasSkeleton, setHasSkeleton] = useState(true)
    const [editModalData, setEditModalData] = useState({ show: false, commission: "", showConfirmButton: false })
    const [editList, setEditList] = useState([])
    const [filterData, setFilterData] = useState({
        variantStates: [], productGroups: [], brands: [], pricingStrategys: [], channels: [], ErrorFilters: []
    });
    const [list, setList] = useState({ list: [] })
    const [toast, setToast] = useState({ text: '', type: 'error' })
    const [filters, setFilters] = useState({
        inActive: false,
        pageCount: 0, currentPage: 1, countInPage: 10, sort: "", by: 1,
        sellStatus: [{ name: "وضعیت ربات فعال", checked: false }, { name: "ربات غیرفعال", checked: false }],
        boxStatus: [{ name: "در باکس فروش", checked: false }, { name: "خارج از باکس فروش", checked: false }],
        variantState: [{ name: "در باکس فروش", checked: false }, { name: "خارج از باکس فروش", checked: false }, { name: "وضعیت ربات فعال", checked: false }, { name: "ربات غیرفعال", checked: false }],
        allVariants: 0,
        hasProducts: false,
        productsListFilters: []
    })

    const [detailFilters, setDetailFilters] = useState({ inBybox: 0, outOfBox: 0, hasError: 0, deActive: 0 })

    const [comments, setComments] = useState({
        show: false,
        variantId: '',
        name: '',
        channelName: ''
    })

    const listFilters = [
        { tag: 'inBybox', label: 'تنوع در باکس ', icon: 'greenItem', activeIcon: 'greenItemActive', urlName: 'inByBoxUnion', filterName: 'در باکس فروش' },
        { tag: 'outOfBox', label: 'تنوع خارج از باکس ', icon: 'yellowItem', activeIcon: 'yellowItemActive', urlName: 'outsideByBoxUnion', filterName: 'خارج از باکس فروش' },
        { tag: 'hasError', label: 'تنوع خطادار ', icon: 'redItem', activeIcon: 'redItemActive', urlName: 'hasErrorUnion' },
        { tag: 'deActive', label: 'تنوع غیرفعال در ربات ', icon: 'grayItem', activeIcon: 'grayItemActive', urlName: 'salesStatusUnion', filterName: 'وضعیت ربات غیرفعال' }
    ]

    //life cycles***********************************

    const [locationKeys, setLocationKeys] = useState([])
    const history = useHistory()

    useEffect(() => {
        return history.listen(location => {
            if (history.action === 'PUSH') {
                setLocationKeys([location.key])
            }
            if (history.action === 'POP') {
                if (locationKeys[1] === location.key) {
                    setLocationKeys(([_, ...keys]) => keys)
                    // Handle forward event
                    checkChange()
                } else {
                    setLocationKeys((keys) => [location.key, ...keys])
                    // Handle back event
                    checkChange()
                }
            }
        })
    }, [locationKeys,])

    const checkChange = () => {
        const check = ["brand", "pricingStrategy", "channel", 'ErrorFilter', 'productGroup']
        let filterDataTemp = { ...filterData };
        check.map(filter => {
            filterDataTemp[`${filter}s`] = urlChecker(filterDataTemp[`${filter}s`], filter);
        })
        setFilterData(filterDataTemp);
        getPriceList();
    }

    useEffect(async () => {
        await getFilterData()
        await getPriceList()
        await checkProgressBar()
    }, [])

    // handle Filters Change
    const divHeight = useRef();
    const [selectedFilters, setSelectedFilters] = useState({})
    const [showMoreFilters, setShowMoreFilters] = useState(false)

    // if on top set navbar to fix 
    const [offset, setOffset] = useState(0);

    useEffect(() => {
        const onScroll = () => setOffset(window.pageYOffset);
        // clean up code
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);
    // end


    useEffect(() => {
        setShowFilters('showLess')
    }, [filterData])

    const setShowFilters = (type) => {
        let tempBoolean = false
        if (type == 'showMore') {
            tempBoolean = true
            setShowMoreFilters(!showMoreFilters)
        }
        let tmpString = ''
        let tmpsSelected = { brands: [], productGroups: [], pricingStrategys: [], channels: [], ErrorFilters: [], variantStates: [] }
        Object.keys(filterData).map(function (key, index) {
            if (filterData[key]) {
                filterData[key].map(item => {
                    if (item.checked) {
                        if (typeof tmpsSelected[key] != 'undefined') {
                            tmpString = tmpString + 'گروه کالا: ' + item.name
                            if (tmpString.length < 120) {
                                tmpsSelected[key].push(item)
                            } else {
                                if (tempBoolean) {
                                    tmpsSelected[key].push(item)
                                }
                            }
                        }
                    }
                })
            }
        });
        if (type == 'showLess') {
            if (tmpString.length < 120) {
                setShowMoreFilters(true)
            } else {
                setShowMoreFilters(false)
            }
        }
        setSelectedFilters({ ...tmpsSelected })
    }

    const checkProgressBar = async () => {
        // complete progressBar
        let local = localStorage.getItem('progressBar')
        if (typeof local !== 'undefined' && local != null) {
            let res = await GetProgressBar()
            if (res && res.data && res.data.success) {
                let tmpLocal = res.data.progressData.progressBar
                if (!tmpLocal.Pricing) {
                    await CompleteProgressBar({ stage: 'Pricing' })
                }
            }
        }
        // complete progressBar
    }

    const determineFilterKey = key => {
        let title = 'فیلتر'
        switch (key) {
            case 'brands':
                title = 'برند'
                break;
            case 'pricingStrategys':
                title = 'استراتژی'
                break;
            case 'channels':
                title = 'کانال'
                break;
            case 'ErrorFilters':
                title = 'خطاها'
                break;
            case 'variantStates':
                title = 'وضعیت تنوع'
                break;
            case 'productGroups':
                title = 'گروه کالا'
                break;
        }

        return title;
    }
    const checkIfFilterAvailable = () => {
        let result = false;
        Object.keys(selectedFilters).map((key, index) => {
            if (selectedFilters[key].length > 0) {
                result = true
            }
        })
        return result
    }

    // change route modal alert
    const [changeRouteModal, setChangeRouteModal] = useState({
        showModal: false,
        unEditedList: [],
        redirectedURL: ''
    })

    useEffect(() => {
        const unlisten = history.block((location) => {
            if (location.pathname == '/pricing') {
                return true
            } else {
                if (changeRouteModal.unEditedList.length > 0 && !changeRouteModal.showModal) {
                    // show modal & set URL
                    let tmp = changeRouteModal;
                    tmp.showModal = true
                    tmp.redirectedURL = location.pathname
                    setChangeRouteModal({ ...tmp })
                    return false;
                } else {
                    return true
                }
            }
        })
        return function cleanup() {
            unlisten()
        }
    }, [])

    const isEditing = type => {
        let tmp = changeRouteModal;
        if (type == 'add') {
            tmp.unEditedList.push('a')
        }
        if (type == 'remove') {
            tmp.unEditedList.pop()
        }
        if (type == 'empty') {
            tmp.unEditedList = []
        }
        setChangeRouteModal({ ...tmp })
    }
    // end of handle Filters Change


    //send data*************************************
    const createServerArray = (array, hasData, value) => {
        let array2 = array
        let temp = []
        array2.forEach(item => {
            if (item.checked === value) {
                if (!hasData) {
                    temp.push(item.value)
                } else {
                    temp.push(item.name)

                }
            }
        })
        return temp
    }

    const getPriceList = async () => {
        setHasSkeleton(true)
        let urlParams = await getFromUrl();
        let params = {
            brand: urlParams.brand ? urlParams.brand : createServerArray(filterData.brands, true, true),
            channel: urlParams.channel ? urlParams.channel : createServerArray(filterData.channels, false, true),
            pricingStrategy: urlParams.pricingStrategy ? urlParams.pricingStrategy : createServerArray(filterData.pricingStrategys, false, true),
            productGroup: urlParams.productGroup ? urlParams.productGroup : createServerArray(filterData.productGroups, false, true),
            errors: urlParams.ErrorFilter ? urlParams.ErrorFilter : createServerArray(filterData.ErrorFilters, false, true),
            page: urlParams.page ? urlParams.page : filters.currentPage,
            countInPage: getFromUrl('countInPage'),
            query: getFromUrl('search'),
            sort: filters.sort,
            by: filters.by,
        }

        if (getFromUrl('activerobotinpromotions')) {
            params.changePricePromotion = true
        }

        if (getFromUrl('withoutchangeprice')) {
            params.changePricePromotion = false
        }

        if (getFromUrl('withoutchangeprice') && getFromUrl('activerobotinpromotions')) {
            delete params.changePricePromotion
        }

        if (urlParams.variantState.includes("ربات غیرفعال")) {
            params.salesStatus = false
        }

        if (urlParams.variantState.includes('در باکس فروش')) {
            params.inByBox = true
        }

        if (urlParams.variantState.includes("خارج از باکس فروش")) {
            params.inByBox = false
        }

        if (urlParams.variantState.includes("خارج از باکس فروش") && urlParams.variantState.includes('در باکس فروش')) {
            delete params.inByBox
        }

        if (urlParams.variantState.includes("خطا")) {
            // params.errors = ["*"]
            delete params.errors;
            params.hasErrorUnion = true
        }

        if (urlParams.ActiveSellStatus && urlParams.InactiveSellStatus) {
            delete params.salesStatus
        } else {
            if (urlParams.ActiveSellStatus == 'true') {
                params.salesStatus = true
            }
            if (urlParams.InactiveSellStatus == 'true') {
                params.salesStatus = false
            }
        }

        if (urlParams.insideBox && urlParams.outsideBox) {
            delete params.inByBox
        } else {
            if (urlParams.insideBox == 'true') {
                params.inByBox = true
            }
            if (urlParams.outsideBox == 'true') {
                params.inByBox = false
            }
        }

        if (urlParams.inByBoxUnion) {
            params.inByBoxUnion = true
        }

        if (urlParams.outsideByBoxUnion) {
            params.inByBoxUnion = false
        }

        if (urlParams.inByBoxUnion && urlParams.outsideByBoxUnion) {
            params.inByBoxUnion = "both"
        }

        if (urlParams.hasErrorUnion) {
            params.hasErrorUnion = true
        }

        if (urlParams.salesStatusUnion) {
            params.salesStatusUnion = false
        }

        let res = await getPricingList(params);

        if (typeof res !== "undefined" && res.data) {
            let tmp = list
            tmp.list = res.data.variantList
            setList({ ...tmp })

            let temp = filters;
            temp.hasProducts = res.data.hasProduct;
            temp.pageCount = res.data.variantListPageCount;
            temp.allVariants = res.data.variantCount;

            // productsListFilters
            let tempURL = await getFromUrl()
            listFilters.map(filteredItem => {
                if (tempURL[filteredItem.urlName] == "true" && !temp.productsListFilters.includes(filteredItem.tag)) {
                    temp.productsListFilters.push(filteredItem.tag)
                }
            })

            setFilters({ ...temp })
            if (res.data.details) {
                let temp = res.data.details
                setDetailFilters({ ...temp })
            }
        }
        setHasSkeleton(false)
    }

    const SubmitEditVariant = async (data) => {
        let editRes = await EditSingleVariantModalCalc(data, openToast)
        if (typeof editRes !== 'undefined') {
            // instead of getting the whole list get only one!
            // await getPriceList()
            await updateVariant(data)
        }
        return editRes
    }

    const SubmitEditSalesPrice = async (data) => {
        let editRes = await ChangeSalesPrice(data, openToast)
        if (typeof editRes !== 'undefined') {
            return editRes
        } else {
            return 'failed'
        }
    }

    const updateVariant = async (data) => {
        let res = await GetSingleVariant(data.variantId, openToast)
        if (res) {
            let tmp = list
            for (let i = 0; i < tmp.list.length; i++) {
                if (tmp.list[i]._id == res._id) {
                    tmp.list[i] = res
                }
            }
            setList({ ...tmp })
            return true
        }
        return false
    }


    //getData***************************************
    const getFilterData = async () => {
        const resBrands = await GetBrands(openToast);
        const resChannels = await GetSellers(openToast);
        const resErrors = await GetErrors(openToast)
        const resProductGroup = await GetproductGroup(openToast)

        // here we should also get errors on seprated method

        let tmpObject = {
            brands: urlChecker(resBrands.data.BrandList, "brand"),
            pricingStrategys: urlChecker(strategyValues, "pricingStrategy"),
            channels: urlChecker(resChannels.data.channelList, "channel"),
            ErrorFilters: urlChecker(resErrors && resErrors.data && resErrors.data.error_list ? resErrors.data.error_list : ErrorsFilterValues, 'ErrorFilter'),
            variantStates: urlChecker(variantState, 'variantState'),
            productGroups: urlChecker(resProductGroup && resProductGroup.data && resProductGroup.data.GroupList ? resProductGroup.data.GroupList : [], 'productGroup')
        }

        setFilterData({ ...tmpObject })
    }
    //functions*************************************
    const urlChecker = (list, key) => {
        let tempList = [];
        let filters = getFromUrl(key) || [];
        switch (key) {
            case "channel":
                list.forEach(item => {
                    if (filters.indexOf(item._id ? item._id : item) >= 0) {
                        tempList.push({ name: item.name ? item.name : item, _id: item._id, checked: true });
                    } else {
                        tempList.push({ name: item.name ? item.name : item, _id: item._id, checked: false });
                    }
                })

                break;
            case "brand":
                list.forEach(item => {
                    if (filters.indexOf(item.name ? item.name : item) >= 0) {
                        tempList.push({ name: item.name ? item.name : item, checked: true });
                    } else {
                        tempList.push({ name: item.name ? item.name : item, checked: false });
                    }
                })

                break;
            case "variantState":
                list.forEach(item => {
                    if (filters.indexOf(item.name ? item.name : item) >= 0) {
                        tempList.push({ name: item.name ? item.name : item, value: item.value || '', checked: true });
                    } else {
                        tempList.push({ name: item.name ? item.name : item, value: item.value || '', checked: false });
                    }
                })
                break;
            case "pricingStrategy":
                list.forEach(item => {
                    if (filters.indexOf(item.value ? item.value : item) >= 0) {
                        tempList.push({ name: item.name ? item.name : item, value: item.value || '', checked: true });
                    } else {
                        tempList.push({ name: item.name ? item.name : item, value: item.value || '', checked: false });
                    }
                })

                break;
            case "ErrorFilter":
                list.forEach(item => {
                    if (filters.indexOf(item.value ? item.value : item) >= 0) {
                        tempList.push({ name: item.name ? item.name : item, value: item.value || '', checked: true });
                    } else {
                        tempList.push({ name: item.name ? item.name : item, value: item.value || '', checked: false });
                    }
                })
                if (getFromUrl('ErrorFilter') == '*') {
                    tempList.map(item => { item.checked = true })
                }
                break;
            case "productGroup":
                list.forEach(item => {
                    if (filters.indexOf(item.name ? item.name : item) >= 0) {
                        tempList.push({ name: item.name ? item.name : item, value: item.name ? item.name : item, checked: true });
                    } else {
                        tempList.push({ name: item.name ? item.name : item, value: item.name ? item.name : item, checked: false });
                    }
                })
                break;
            default:
                break;
        }

        return tempList;
    }
    const checkUrl = () => {
        let url = new URLSearchParams(window.location.search);
        return url.get('brand') || url.get('channel') || url.get('variantState') || url.get('withoutchangeprice') || url.get('activerobotinpromotions') || url.get('ActiveSellStatus') || url.get('InactiveSellStatus') || url.get('pricingStrategy') || url.get('insideBox') || url.get('outsideBox') || url.get('ErrorFilter') || url.get('productGroup')
    }

    const openToast = (error, type) => {
        if (typeof type == 'undefined') {
            setToast({ ...toast, text: error, type: 'error' })
        } else {
            setToast({ ...toast, text: error, type: type })
        }
    }
    const getFromUrl = (param) => {
        let defaultParams = {
            brand: [],
            withoutchangeprice: false,
            activerobotinpromotions: false,
            ActiveSellStatus: false,
            InactiveSellStatus: false,
            insideBox: false,
            outsideBox: false,
            inByBoxUnion: false,
            outsideByBoxUnion: false,
            salesStatusUnion: false,
            hasErrorUnion: false,
            pricingStrategy: [],
            productGroup: [],
            ErrorFilter: [],
            channel: [],
            variantState: [],
            countInPage: 10,
            page: 1,
            search: "",
            sort: '',
            by: 1,
        }

        let url = new URLSearchParams(window.location.search);
        let tmpStrategy = [];
        let tmpBrand = [];
        let tmpError = [];
        let tmpChannel = [];
        let tmpVariantState = []
        let tmpProductGroup = []
        if (url.get('pricingStrategy')) {
            tmpStrategy = url.get('pricingStrategy').split("*");
            tmpStrategy = tmpStrategy.map(el => el.replace(/-/g, ' '));
        }
        if (url.get('productGroup')) {
            tmpProductGroup = url.get('productGroup').split("*");
            tmpProductGroup = tmpProductGroup.map(el => el.replace(/-/g, ' '));
        }
        if (url.get('ErrorFilter')) {
            if (url.get('ErrorFilter') == "*") {
                tmpError = ["*"]
            } else {
                tmpError = url.get('ErrorFilter').split("*");
                tmpError = tmpError.map(el => el.replace(/-/g, ' '));
            }
        }
        if (url.get('brand')) {
            tmpBrand = url.get('brand').split("*");
            tmpBrand = tmpBrand.map(el => el.replace(/-/g, ' '));
        }
        if (url.get('variantState')) {
            tmpVariantState = url.get('variantState').split("*");
            tmpVariantState = tmpVariantState.map(el => el.replace(/-/g, ' '));
        }
        if (url.get('channel')) {
            tmpChannel = url.get('channel').split("*");
            tmpChannel = tmpChannel.map(el => el.replace(/-/g, ' '));
        }
        if (url) {
            defaultParams = {
                brand: tmpBrand,
                variantState: tmpVariantState,
                withoutchangeprice: url.get('withoutchangeprice') || false,
                activerobotinpromotions: url.get('activerobotinpromotions') || false,
                ActiveSellStatus: url.get('ActiveSellStatus') || false,
                InactiveSellStatus: url.get('InactiveSellStatus') || false,
                insideBox: url.get('insideBox') || false,
                outsideBox: url.get('outsideBox') || false,
                inByBoxUnion: url.get('inByBoxUnion') || false,
                outsideByBoxUnion: url.get('outsideByBoxUnion') || false,
                salesStatusUnion: url.get('salesStatusUnion') || false,
                hasErrorUnion: url.get('hasErrorUnion') || false,
                pricingStrategy: tmpStrategy,
                productGroup: tmpProductGroup,
                ErrorFilter: tmpError,
                channel: tmpChannel,
                countInPage: url.get('countInPage') || 10,
                page: url.get('page'),
                search: url.get('search') || '',
                sort: url.get('sort'),
                by: url.get('by'),
            }
        }
        if (param) {
            return defaultParams[param];
        } else {
            return defaultParams;
        }
    }


    const setToUrl = (param, value) => {
        let url = new URLSearchParams(window.location.search);
        if (Array.isArray(value)) {
            let tempString = "";
            value.map(item => {
                tempString ? tempString = `${tempString}*${item}` : tempString = item;
            })
            value.length > 0 ? url.set(param, tempString) : url.delete(param)
        } else {
            url.set(param, value);
        }
        props.history.push(window.location.pathname + "?" + url.toString());

        if (param != "page") {
            getPriceList();
        }
    }

    const deleteFromUrl = async (param) => {
        let url = new URLSearchParams(window.location.search);
        url.delete(param);
        props.history.push(window.location.pathname + "?" + url.toString());
        let filterDataTemp = { ...filterData };
        filterDataTemp[`${param}s`] = urlChecker(filterDataTemp[`${param}s`], param);
        setFilterData({ ...filterDataTemp });
        getPriceList()
    }

    const searcher = (searchlist, key) => {
        let searchedList = []
        if (key) {
            searchlist.map(item => {
                if (item.name.includes(key)) {
                    searchedList.push(item);
                }
            })
            return searchedList;
        } else {
            return searchlist;
        }
    }

    const handleProductListFilters = (tag, item) => {
        let tmp = filters
        setToUrl('page', 1)
        if (tag != 'allItems') {
            if (tmp.productsListFilters.includes(tag)) {
                // delete selected filter
                tmp.productsListFilters.map((el, index) => {
                    if (el == tag) {
                        tmp.productsListFilters.splice(index, 1);
                    }
                })

                // delete from url
                let req = {
                    name: item.filterName,
                    urlName: item.urlName,
                    checked: false
                }
                if (getFromUrl(req.urlName)) {
                    deleteFromUrl(req.urlName, req.checked)
                } else {
                    setToUrl(req.urlName, true)
                }

            } else {
                tmp.productsListFilters.push(tag)

                // add to url
                let req = {
                    name: item.filterName,
                    urlName: item.urlName,
                    checked: true
                }
                // handleSelect(tag, req)
                if (getFromUrl(req.urlName)) {
                    deleteFromUrl(req.urlName, req.checked)
                } else {
                    setToUrl(req.urlName, true)
                }
            }
        } else {
            // delete all from url
            item.map(filterItem => {
                if (tmp.productsListFilters.includes(filterItem.tag)) {
                    deleteFromUrl(filterItem.urlName, false)
                }
            })
            tmp.productsListFilters = []
        }
        setFilters({ ...tmp })
    }

    //handlers**************************************
    const searchHandler = (val) => {
        setToUrl('page', 1)
        setToUrl('search', val)
    }

    const closeModalHandler = async (value) => {
        if (value) {
            let modal = editModalData;
            modal.show = false;
            setEditModalData({ ...modal });
        }
        if (value == 'submited') {
            await getPriceList()
        }
    }

    const selectHandler = async (tag, value) => {
        let filterDataTemp = filterData;
        let url = getFromUrl(tag);

        if (value.checked) {
            url.splice(url.indexOf(tag === "channel" ? value._id : (tag === "pricingStrategy" || tag === "ErrorFilter" ? value.value : value.name)), 1);
        } else {
            tag === "pricingStrategy" || tag === "ErrorFilter" || tag == 'productGroup' ?
                url.push(value.value) :
                url.push(tag === "channel" ? value._id : (value.name ? value.name : value))
        }
        setToUrl('page', 1)
        setToUrl(tag, url);

        filterDataTemp[`${tag}s`] = urlChecker(filterDataTemp[`${tag}s`], tag);

        if (tag == 'ErrorFilter') {
            if (value.value == '') {
                filterDataTemp.ErrorFilters.map(item => {
                    item.checked = false
                })
            }
            if (value.value == '*') {
                filterDataTemp.ErrorFilters.map(item => {
                    item.checked = true
                })
            }
        }
        setFilterData({ ...filterDataTemp });
    }


    const pricingActiveHandler = async (id) => {
        let priceList = list.list
        let data = priceList.find(item => item._id === id)
        data.robot.salesStatus = !data.robot.salesStatus
        data.robot.variantId = data._id;
        let res = await EditSingleVariantModalCalc(data.robot)
        if (res) {
            console.log(res);
            getPriceList()
        }
    }

    const repriceVariant = async (id) => {
        let res = await RepriceVariant({ productId: id }, openToast)
        console.log(res, 'reprice');
    }

    const setModal = async (id, type) => {
        if (typeof type !== "undefined" && type === 'multi') {
            let editVaraintTemp = { ...editModalData };
            editVaraintTemp.show = !editVaraintTemp.show;
            setEditModalData(editVaraintTemp);
        } else {
            if (typeof props.user !== "undefined" && props.user.permission.pricingPanel.includes("Edit")) {
                let ModalData = editModalData;
                ModalData.show = !ModalData.show;
                if (typeof id !== "undefined") {
                    let EditList = [];
                    let variant = list.list.find(i => i._id === id)
                    if (variant) {
                        EditList.push(variant)
                        setEditList([...EditList])
                    }
                }
                setEditModalData({ ...ModalData })
            }
        }
    }

    const editCheckboxHandler = (data) => {
        let list = [...editList]
        let index = list.findIndex(i => i._id === data._id)
        if (index < 0) {
            list.push(data)
            setEditList([...list])
        } else {
            list.splice(index, 1)
            setEditList([...list])
        }
    }
    const sortHandler = (value) => {
        let Filters = filters;
        Filters.sort = value;
        Filters.by = -Filters.by;
        setFilters({ ...Filters })
        setToUrl('sort', value)
        setToUrl('by', filters.by)
    }
    const setFilter = (propertyName, value) => {
        let filter = filters;
        filter[propertyName] = value;
        setFilters({ ...filter })
    }
    const pageSetter = (number) => {
        setFilter("currentPage", number)
        setToUrl('page', number)
        getPriceList()
    }

    const handleDropdownSearch = (tag, query) => {
        let filterDataTemp = { ...filterData };
        filterDataTemp[tag] = query;
        setFilterData(filterDataTemp);
    }

    const handleSelect = (tag, val) => {
        let label = tag == 'promotion' ? tag : 'variantState'
        let variantObject = {
            checked: false,
            name: val.name,
            value: ""
        }
        setToUrl('page', 1)
        if (tag !== 'promotion') {
            if (val.name == 'وضعیت ربات فعال') {
                if (getFromUrl('ActiveSellStatus')) {
                    deleteFromUrl("ActiveSellStatus", val.checked)
                } else {
                    setToUrl("ActiveSellStatus", true)
                }
            }
            if (val.name == 'ربات غیرفعال') {
                variantObject.value = 'ActiveSellStatus'
                if (getFromUrl('InactiveSellStatus')) {
                    deleteFromUrl("InactiveSellStatus", false)
                    variantObject.checked = true
                } else {
                    setToUrl("InactiveSellStatus", true)
                    variantObject.checked = false
                }
            }
            if (val.name == 'در باکس فروش') {
                variantObject.value = "insideBox"
                if (getFromUrl('insideBox')) {
                    deleteFromUrl("insideBox", false)
                    variantObject.checked = true
                } else {
                    setToUrl("insideBox", true)
                    variantObject.checked = false
                }
            }
            if (val.name == 'خارج از باکس فروش') {
                variantObject.value = 'outsideBox'
                if (getFromUrl('outsideBox')) {
                    deleteFromUrl("outsideBox", false)
                    variantObject.checked = true
                } else {
                    setToUrl("outsideBox", true)
                    variantObject.checked = false
                }
            }
            selectHandler(label, variantObject)
        } else {
            if (val.name == 'بدون تغییر قیمت') {
                variantObject.value = 'withoutchangeprice'
                if (getFromUrl('withoutchangeprice')) {
                    deleteFromUrl("withoutchangeprice", false)
                    variantObject.checked = true
                } else {
                    setToUrl("withoutchangeprice", true)
                    variantObject.checked = false
                }
            }
            if (val.name == 'فعال‌سازی ربات در تخفیف هوشمند') {
                variantObject.value = 'activerobotinpromotions'
                if (getFromUrl('activerobotinpromotions')) {
                    deleteFromUrl("activerobotinpromotions", false)
                    variantObject.checked = true
                } else {
                    setToUrl("activerobotinpromotions", true)
                    variantObject.checked = false
                }
            }
        }
    }
    const handleDeleteAll = async () => {
        let url = new URLSearchParams(window.location.search);
        const Filters = ['ActiveSellStatus', 'brand', 'channel', 'InactiveSellStatus', 'pricingStrategy', 'insideBox', 'outsideBox', 'ErrorFilter', 'variantState', 'activerobotinpromotions', 'withoutchangeprice', 'productGroup']
        let filterDataTemp = filterData;
        Filters.forEach(item => {
            url.delete(item);
        })
        props.history.push(window.location.pathname + "?" + url.toString());
        Filters.forEach(item => {
            filterDataTemp[`${item}s`] = urlChecker(filterDataTemp[`${item}s`], item);
        })
        setFilterData({ ...filterDataTemp });
        handleProductListFilters('allItems', listFilters)
        let tmpSelected = selectedFilters
        Object.keys(tmpSelected).map((key, index) => {
            tmpSelected[key] = [];
        });
        setSelectedFilters({ ...tmpSelected })
        await getPriceList()
    }

    const selectProductsCheckedHandler = (name) => {
        let temp = true;
        switch (name) {
            case "همه":
                list.list.forEach(variant => {
                    if (editList.findIndex(item => item._id === variant._id) === -1) {
                        temp = false;
                    }
                })
                return temp;
            case "هیچکدام":
                list.list.map(variant => {
                    if (editList.findIndex(item => item._id === variant._id) !== -1) {
                        temp = false;
                    }
                })
                return temp;

            case "کالاهای بدون باکس":
                !selectProductsCheckedHandler('همه') && !selectProductsCheckedHandler('هیچکدام') ?
                    list.list.map(variant => {
                        if (!variant.inByBox) {
                            if (editList.findIndex(item => item._id === variant._id) === -1) {
                                temp = false;
                            }
                        } else {
                            if (editList.findIndex(item => item._id === variant._id) >= 0) {
                                temp = false;
                            }
                        }
                    }) : temp = false
                return temp;
            case "کالاهای در باکس":
                !selectProductsCheckedHandler('همه') && !selectProductsCheckedHandler('هیچکدام') ? list.list.map(variant => {
                    if (variant.inByBox) {
                        if (editList.findIndex(item => item._id === variant._id) === -1) {
                            temp = false;
                        }
                    } else {
                        if (editList.findIndex(item => item._id === variant._id) >= 0) {
                            temp = false;
                        }
                    }
                }) : temp = false
                return temp;
            default:
                break;
        }
    }
    //renderers******************************************************************************************
    const emptyRenderer = () => {
        let url = window.location.search
        if (list.list.length == 0 && filters.hasProducts && url.length < 1) {
            return <div className={style.empty2}>
                <div className={style.image}>
                    <img src={noVariantEmptyState} />
                </div>
                <p>اینجا می‌تونید وضعیت باکس تنوع‌های تکمیل اطلاعات شده رو بررسی کنید</p>
                <p className={style.boldText}>لطفا اطلاعات هر تنوع (قیمت خرید و حداقل حاشیه سود) رو از صفحه تنوع‌ها تکمیل کنید</p>
                <Button type="solid"
                    label={"ورود به صفحه‌ی تنوع‌ها"}
                    onclick={() => {
                        props.history.push("/variants")
                    }} />
            </div>
        } else if (list.list.length == 0 && filters.hasProducts && url.length > 1) {
            return <div className={style.noResult}>
                <div className={style.image}>
                    <img src={noResultEmptyState} />
                </div>
                <p className={style.boldText}>نتیجه‌ای یافت نشد!</p>
                <p>لطفا عبارت دیگری جستجو کنید</p>
                <p className={style.grayText}>درصورت اطمینان از وجود این تنوع در دیجی‌کالا، تنوع‌ها را به‌روز رسانی کنید</p>
                <div className={style.addPannelBtnWrapper}>
                    <Button type="solid"
                        label={"بازگشت"}
                        onclick={() => props.history.goBack()} />
                    <Button type="noBorder"
                        label={"ورود به صفحه‌ی تنوع‌ها"}
                        onclick={() => {
                            props.history.push("/variants")
                        }} />
                </div>
            </div>

        } else if (list.list.length == 0 && !filters.hasProducts) {
            return <div className={style.empty2}>
                <div className={style.image}>
                    <img src={noVariantEmptyState} />
                </div>
                <p>اینجا می‌تونید وضعیت باکس تنوع‌های تکمیل اطلاعات شده رو بررسی کنید</p>
                <p className={style.boldText}>لطفا اطلاعات هر تنوع (قیمت خرید و حداقل حاشیه سود) رو از صفحه تنوع‌ها تکمیل کنید</p>
                <Button type="solid"
                    label={"ورود به صفحه‌ی تنوع‌ها"}
                    onclick={() => {
                        props.history.push("/variants")
                    }} />
            </div>
        }

    }
    const closeToast = () => {
        let editVaraintTemp = { ...editModalData };
        delete editVaraintTemp.toast;
        setEditModalData(editVaraintTemp);
    }

    const addChannel = async (email, password) => {
        let params = { username: toEnglishNumber(email), password: toEnglishNumber(password) };
        let res = await SubmitAddChannel(params)
        setEditModal({ ...editModal, show: false })
        await getPriceList()
        return res;
    }

    const openCommentInsights = async (id, name, channelName) => {
        setComments({
            ...comments,
            show: !comments.show,
            variantId: id,
            name: name,
            channelName: channelName
        })
    }

    if (hasSkeleton) {
        return <Skeleton />
    } else {
        return (
            <div className={style.wrapper}>
                <EditChannelModal
                    show={editModal.show}
                    closemodal={() => setEditModal({ ...editModal, show: false })}
                    email=''
                    editchannel={addChannel}
                />
                <CommentInsight
                    value={comments.show}
                    title={'تحلیل دیدگاه‌ها'}
                    data={{ dkp: comments.variantId, name: comments.name, channelName: comments.channelName }}
                    parentClose={() => setComments({ ...comments, show: false, dkp: '', name: '', channelName: '' })}
                />
                <Toast tag="errorToast" value={toast.text} text={toast.text} parentClose={() => setToast('')} type={toast.type} />
                <Toast tag="checkError" value={editModalData.toast} text={editModalData.toast} parentClose={closeToast} />

                {
                    props.user.expiredAccount &&
                    <div className={style.gradientWrapper}>
                        <GradientToast tag="test" value={true}>
                            <>
                                <p className={style.expiredTitle}>شارژ کیف پول شما تمام شده‌است.</p>
                                <p className={style.expiredText}>برای فعال‌سازی مجدد ربات، کیف پول خود را شارژ کنید.</p>
                                <Link className={style.expiredLink} to={'/chargewallet'}>ورود به صفحه‌ی  شارژ کیف پول  </Link>
                            </>
                        </GradientToast>
                    </div>
                }

                {
                    props.user.disconnected.status &&
                    <div className={style.gradientWrapper}>
                        <GradientToast tag="test" value={true}>
                            <>
                                <p className={style.expiredTitle}>{disconnectTextGenerator(props.user.disconnected.channelName)}</p>
                                <p className={style.expiredText}>جهت اتصال دوباره موبیشا به پنل، لطفا اطلاعات خود را در صفحه پنل دیجی‌کالا به‌روز رسانی کنید</p>
                                <Link className={style.expiredLink} to={'/channels'}>ورود به صفحه‌ی  پنل دیجی‌کالا  </Link>
                            </>
                        </GradientToast>
                    </div>
                }

                {/* <div className={style.gradientWrapper}>
                    <GradientToast tag="test" value={true}>
                        <GeneralWarning />
                    </GradientToast>
                </div> */}

                <EditModal2
                    list={editList}
                    show={editModalData.show}
                    closeModal={closeModalHandler}
                    accountId={props.user.account._id}
                />
                <ChangeRouteModal
                    value={changeRouteModal.showModal}
                    title={'ویرایش تنوع'}
                    parentClose={() => setChangeRouteModal({ ...changeRouteModal, showModal: false })}
                    unEditedLength={changeRouteModal.unEditedList}
                    buttonLabel={"بازگشت به صفحه قیمت‌گذاری"}
                    urlDirect={changeRouteModal.redirectedURL}
                    emptyEditedList={() => isEditing('empty')}
                />
                <h1>
                    قیمت‌گذاری
                </h1>

                {filterData.channels && filterData.channels.length > 0 ?
                    <React.Fragment>
                        {(list.list.length > 0 || (list.list.length == 0 && filters.hasProducts && getFromUrl('search'))) &&
                            <div className={style.searchbarWrapper}>
                                <Searchbar
                                    placeholder={"عنوان یا کد کالا یا کد تنوع"}
                                    value={getFromUrl('search') ? getFromUrl('search') : ''}
                                    searchValue={(value) => searchHandler(value)}
                                />
                            </div>}

                        <div className={style.mobileFilters}>
                            <MobileFilters
                                filterData={filterData}
                                FilterArrays={FilterArrays}
                                selectHandler={selectHandler}
                                handleSelect={handleSelect}
                                getFromUrl={getFromUrl}
                                isFiltersSelected={Object.keys(selectedFilters).map(el => { if (selectedFilters[el].length > 0) { return true } else { return false } })}
                            />
                        </div>

                        <PricingFilters
                            filterData={filterData}
                            FilterArrays={FilterArrays}
                            checkUrl={checkUrl}
                            handleDeleteAll={handleDeleteAll}
                            searcher={searcher}
                            handleDropdownSearch={handleDropdownSearch}
                            deleteFromUrl={deleteFromUrl}
                            selectHandler={selectHandler}
                            handleSelect={handleSelect}
                            getFromUrl={getFromUrl}
                        />

                        {/* New Show Filters */}
                        <div
                            className={style.dropdownWrapperFilters}
                            ref={divHeight}
                        >
                            {Object.keys(selectedFilters).map((selectedFilter, keyIndex) => <React.Fragment key={keyIndex}>
                                {selectedFilters[selectedFilter].length > 0 ? <>
                                    {selectedFilters[selectedFilter].map((item, key) => <div
                                        className={style.singleKeyItem}
                                        key={`item_${key}`}
                                    >
                                        <p>{determineFilterKey(selectedFilter)}: {item.name}</p>
                                        <span
                                            onClick={() => { selectHandler(selectedFilter.slice(0, -1), item); getPriceList() }}
                                        >e</span>
                                    </div>)}
                                </>
                                    :
                                    null}
                            </React.Fragment>)}

                            <div className={style.moreInfoWrapper}>
                                {!showMoreFilters && checkIfFilterAvailable() ? <p
                                    className={style.showMore}
                                    onClick={() => setShowFilters('showMore')}
                                >
                                    نمایش بیشتر
                                </p> : null}
                                {checkIfFilterAvailable() ? <p
                                    className={style.filterRemover}
                                    onClick={() => handleDeleteAll()}
                                >
                                    حذف همه فیلترها
                                </p> : null}
                            </div>
                        </div>
                        {/*End of New Show Filters */}
                        {list.list.length > 0 &&
                            <React.Fragment>
                                <div className={style.pagination}>
                                    <div className={style.Dropdown}>
                                        <Pagination
                                            currentPage={parseInt(getFromUrl("page")) ? parseInt(getFromUrl("page")) : filters.currentPage}
                                            pageCount={filters.pageCount}
                                            setPage={pageSetter}
                                        />
                                        <TinyDropdown
                                            placeholder={getFromUrl('countInPage')}
                                            dropdownList={["10", "25", "50", "75", "100"]}
                                            selected={selected => {
                                                setToUrl("countInPage", selected)
                                                setToUrl("page", 1)
                                                // getPriceList()
                                            }} />
                                        <div className={style.label}>تعداد نمایش در صفحه</div>
                                        <div className={style.verticalLine}></div>
                                        <div
                                            className={style.variantCount}>{toPersianNumber(filters.allVariants) + " تنوع "}</div>
                                    </div>

                                </div>
                            </React.Fragment>}

                        <PricingColoredFilters
                            listFilters={listFilters}
                            filters={filters}
                            handleProductListFilters={handleProductListFilters}
                            detailFilters={detailFilters}
                            handleDeleteAll={handleDeleteAll}
                        />

                        {/* New Desktop List Header */}
                        <div className={style.desktopHeader}>
                            {list.list.length > 0 && <div className={style.hiddenListShadow}></div>}
                            <div className={style.listWrapper} style={list.list.length < 1 ? { overflowX: 'hidden' } : null}>

                                {list.list.length > 0 && <>
                                    <div
                                        style={offset > 580 && (sessionStorage.getItem("sideBarOpen") && sessionStorage.getItem("sideBarOpen") == 'false') ? { width: 'calc(100% - 140px)' } : (offset > 580 ? { width: 'calc(100% - 280px)' } : null)}
                                        className={offset > 580 ? style.listHeaderShadowFixed : style.listHeaderShadow}>
                                        <div className={style.listHeader}>
                                            <div className={style.listHeaderFlexItem303}>مشخصات کالا</div>
                                            <div className={style.listHeaderFlexItem42}>ربات</div>
                                            <div className={style.listHeaderFlexItem96}>
                                                <p>قیمت فروش</p>
                                                <div className={style.divider}></div>
                                                <p>برنده باکس</p>
                                            </div>
                                            <div className={style.listHeaderFlexItem112}>
                                                <p>حداقل قیمت<span>(ریال)</span></p>
                                                <div className={style.divider}></div>
                                                <p>حداکثر قیمت<span>(ریال)</span></p>
                                            </div>

                                            <div className={style.listHeaderFlexItem214}>
                                                <p>حداقل حاشیه سود</p>
                                                <div className={style.divider}></div>
                                                <p>قیمت خرید<span>(ریال)</span></p>
                                            </div>
                                            <div className={style.listHeaderFlexItem32noMargin}></div>
                                            <div className={style.listHeaderFlexItem94}></div>
                                        </div>
                                    </div>
                                    <div className={style.listHeader}></div>
                                </>}

                                {list.list.length > 0 ?
                                    list.list.map((item, index) => {
                                        return <div className={style.list} key={index}>
                                            <PricingCard
                                                number={index + 1}
                                                threeDotHandler={setModal}
                                                checked={editList.length > 0 && editList.findIndex(i => i._id === item._id) >= 0 ? true : false}
                                                data={item}
                                                sort={sortHandler}
                                                handleCheckBox={editCheckboxHandler}
                                                activeHandler={pricingActiveHandler}
                                                isEditing={isEditing}
                                                SubmitEditVariant={SubmitEditVariant}
                                                SubmitEditSalesPrice={SubmitEditSalesPrice}
                                                openToast={openToast}
                                                openCommentInsights={openCommentInsights}
                                                hasManyChannels={filterData.channels.length > 1 ? true : false}
                                                repriceVariant={repriceVariant}
                                            />
                                        </div>
                                    })
                                    :
                                    emptyRenderer()
                                }
                            </div>
                        </div>
                        {/* End of New Desktop List Header */}
                        {/* New Mobile List */}
                        <div className={style.mobileHeader}>
                            <div className={style.mobileListWrapper}>
                                {list.list.length > 0 ?
                                    list.list.map((item, index) => {
                                        return <React.Fragment key={`mobile_${index}`}>
                                            <MobilePricingCard
                                                threeDotHandler={setModal}
                                                checked={editList.length > 0 && editList.findIndex(i => i._id === item._id) >= 0 ? true : false}
                                                data={item}
                                                sort={sortHandler}
                                                handleCheckBox={editCheckboxHandler}
                                                activeHandler={pricingActiveHandler}
                                                isEditing={isEditing}
                                                SubmitEditVariant={SubmitEditVariant}
                                                SubmitEditSalesPrice={SubmitEditSalesPrice}
                                                openToast={openToast}
                                                hasManyChannels={filterData.channels.length > 1 ? true : false}
                                            />
                                        </React.Fragment>
                                    })
                                    :
                                    emptyRenderer()
                                }
                            </div>
                        </div>
                        {/* End of New Mobile List */}
                        {list.list.length > 0 && <div className={style.paginationTwo}>
                            <Pagination
                                currentPage={parseInt(getFromUrl("page")) ? parseInt(getFromUrl("page")) : filters.currentPage}
                                pageCount={filters.pageCount}
                                setPage={pageSetter} />
                        </div>}

                        {list.list.length > 0 && <div className={style.mobilePagination}>
                            <MobilePagination
                                currentPage={parseInt(getFromUrl("page")) ? parseInt(getFromUrl("page")) : filters.currentPage}
                                pageCount={filters.pageCount}
                                setPage={pageSetter}
                            />
                        </div>}

                    </React.Fragment>
                    : <div className={style.empty}>
                        <div className={style.image}>
                            <img src={noVariantEmptyState} />
                        </div>
                        <p>اینجا می‌تونید وضعیت باکس تنوع‌های تکمیل اطلاعات شده رو بررسی کنید</p>
                        <p className={style.boldText}>برای شروع پنل دیجی‌کالا رو ثبت کنید</p>
                        <div className={style.addPannelBtnWrapper}>
                            <Button type="solid"
                                label={"ثبت پنل جدید"}
                                onclick={() => props.history.push("/channels")}
                            />
                            <Button type="noBorder"
                                label={" ورود به صفحه پنل دیجی کالا"}
                                onclick={() => props.history.push("/channels")}
                            />
                        </div>
                    </div>
                }
            </div>
        )
    }
}
export default withRouter(Pricing)